import styles from "./main.module.css";
import { Box, Button, Flex, Grid, GridItem, Image, Table,Th,Tr,
TableContainer,Thead,Heading,Tbody,Td, TableCaption,Text } from "@chakra-ui/react";
import { MdOutlineFileDownload as DownloadIcon } from "react-icons/md";
import React,{useRef,useState} from 'react';
import logo from  "../../../../svg/cipm-logo.svg";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useQuery } from "react-query";
import apiCall from "../../../../utils/apiCall";
import { Loader } from "../../../../customs";
import Select from "../../../../components/Select";

const daysOfWeek = [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ]; 
const monthOfYear = [
  'January',
  'Feburary',
  'March',
  'April',
  'May','June','July','August','September','October','November','December'
]

const StatementResult =({ data,levels,periods }:any) =>  {
  //const examYear = new Date(data?.ExamEndDate || null).getFullYear();
  //console.log(levels,periods,'data');
  const pdfRef = useRef<any>(null);
  const [mes,set_mes] = useState<string>('Result not published yet!');
  const [selected_level,set_selected_level] = useState<any>(null);
  const [selected_period,set_selected_period] = useState<any>(null);
  const {data:details,isLoading} = useQuery(['exam-details'+selected_level?.Id || selected_period?.Id || data.Level.Id || data.PeriodId],{
    queryFn:async()=>await apiCall().get(`/Exam/statementOfResultDetailsAdmin?StudentNo=${data.StudentNo}&LevelId=${selected_level?.Id || data.Level.Id}&ExamPeriodId=${selected_period?.Id || data.ExamPeriodId}`).then((res:any)=>{
      //console.log(res,'res')
      set_mes(res?.response?.data?.Message)
      return res;
    }),
    enabled:Boolean(selected_level?.Id || selected_period?.Id || data.Level.Id || data.PeriodId),
    select(data:any){
      //console.log(data,'details')
      return data?.data?.Data;
    }
  });

 
  

  //console.log(data,'data')
  
  const downloadPdf = () =>{
    const input = pdfRef.current;
    if(pdfRef && pdfRef.current){
      //pdfRef.current.style.margin = '20px 30px'
      html2canvas(input).then((canvas:any)=>{
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p','mm','a4',true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth/imgWidth,pdfHeight/imgHeight);
        // const imgX = (pdfWidth - imgWidth * ratio)/2;
        const imgX = 5;
        const imgY = 5;
        pdf.addImage(imgData,'PNG',imgX,imgY,imgWidth*ratio,imgHeight*ratio);
        pdf.save(`statement of result.pdf`);
      })
    }
    
  }

  return (
    <>{
       <Flex  pos="relative" width="900px" justify="center" align="center" >
      {/* <Image src={logo} width="60%" pos="absolute" /> */}
      <Box  width="100%" bg="rgba(255,255,255,0.8)" height="100%" pos="relative" zIndex="2">
        <Flex alignItems="center" justify="flex-end" gap="20px">
        <Select placeholder="Period" options={periods?.map((e:any)=>({...e,['value']:e.Id,['label']:e.ExamName}))} onChange={(value:any) => set_selected_period(value)}/>
          <Select placeholder="Level" options={levels?.map((e:any)=>({...e,['value']:e.Id,['label']:e.Name}))} onChange={(value:any)=> set_selected_level(value)} />
          <Button leftIcon={<DownloadIcon />} onClick={downloadPdf} bg="var(--white-color)" color="var(dark-green-color)">Download Result</Button>
        </Flex>
       {isLoading?<Loader/>:details? <Box ref={pdfRef} p="0 10px 10px" >
            <Flex justify="flex-end" p="0 20px 0 0" >
              <Image src={require('../../../../svg/logo.png')}
                  width="80px"
              />
            </Flex> 
            <Heading m="5px 0" fontSize="18px" textAlign="center"> PROFESSIONAL EXAMINATION<br/>STATEMENT OF RESULT</Heading>
            <Heading m="5px 0 0" p="0 20px 0 0" fontSize="16px" textAlign='right'>{monthOfYear[new  Date(details?.DateGenerated).getMonth()]} {new Date(details.DateGenerated).getDate()} {new Date(details.DateGenerated).getFullYear()}</Heading>
            <Box padding="0 40px">
              <Grid  gap="5px" gridTemplateColumns="1fr" width="100%"  >
              <GridItem as={Grid} gridTemplateColumns="180px 1fr">
                <Box fontWeight="500">{data?.StudentNo}</Box>
              </GridItem>
              <GridItem as={Grid} gridTemplateColumns="180px 1fr" >
                <Box fontWeight="500">{data?.FirstName+' '+ data?.LastName}</Box>
              </GridItem>
              
              <GridItem as={Grid} gridTemplateColumns="180px 1fr">
                <Box fontWeight="500">{data?.Address || 'Address Not Available'}</Box>
              </GridItem>
            </Grid>
            <Text m="25px 0 10px">Dear Sir/Madam</Text>
            <b>{data?.ExamPeriod} EXAMINATIONS - {details?.Level} EXAMINATION &nbsp; | &nbsp; {details?.Status}</b>
            <Text>Following the Examinations held on {daysOfWeek[(new Date(details.ExamStartDate))?.getDay()]} {(new Date(details.ExamStartDate))?.getDate()} of {monthOfYear[(new Date(details.ExamStartDate))?.getMonth()]} to {daysOfWeek[(new Date(details.ExamEndDate))?.getDay()]} {(new Date(details.ExamEndDate))?.getDate()} of {monthOfYear[(new Date(details.ExamEndDate))?.getMonth()]} {(new Date(details.ExamEndDate)).getFullYear()}, Your Result is as Follow: </Text>
            <TableContainer >
              <Table variant='simple' className="result-table">
                {/* <TableCaption fontWeight="bold" textAlign="left" p="15px 0 15px 0" placement="top">2023 PROFESSIONAL EXAMINAITON STATEMENT OF RESULT</TableCaption> */}
                <Thead>
                  <Tr>
                    <Th w="50px">S/N</Th>
                    <Th>SUBJECT</Th>
                    <Th>GRADE</Th>
                  
                  </Tr>
                </Thead>
                <Tbody>
                 
                 {details && details?.Subjects && details.Subjects?.length > 0? details.Subjects?.map((eSubject:any,ind:number)=><Tr key={eSubject.SN}>
                    <Td w="50px">{ind+1}</Td>
                    <Td>{eSubject?.SubjectName}</Td>   
                    <Td>{eSubject?.SubjectGrade || 'NA'}</Td>
                                
                  </Tr>)
                  :<></>}
                
                
                </Tbody>
              
              </Table>
            </TableContainer>
            {/* <Text mt="10px">
              {details.Message} <b>{details.Status} {details.Level} </b> <br></br> <b>{details.NextLevel || 'N/A'} </b>
            </Text> */}
            <Text mt="10px">
              {/* In consequence of the above, you have <b>{details.Status} {details.Level} EXAMINATION</b> Level of the  Institute's Examination.<br></br> Congratulations! You are therefore expected to take <b>{details.NextLevel || 'N/A'} EXAMINATION</b>  in the next diet. */}
              {details?.Message}
            </Text>
            <Flex justify="flex-end">
              <TableContainer width="350px" m="20px 0">
                <Table className="key-table">
                  <TableCaption textAlign="left" fontWeight="bold" placement="top">KEY FOR RESULT</TableCaption>
                  <Tbody>
                    <Tr>
                      <Td>80-100</Td>
                      <Td>A</Td>
                      <Td>Distinction</Td>
                    </Tr>
                    <Tr>
                      <Td>70-79</Td>
                      <Td>B</Td>
                      <Td>Good</Td>
                    </Tr>
                    <Tr>
                      <Td>60-69</Td>
                      <Td>C</Td>
                      <Td>Credit</Td>
                    </Tr>
                    <Tr>
                      <Td>50-59</Td>
                      <Td>P</Td>
                      <Td>Pass</Td>
                    </Tr>
                    <Tr>
                      <Td>0-49</Td>
                      <Td>F</Td>
                      <Td>Failed</Td>
                    </Tr>
                    <Tr>
                      <Td></Td>
                      <Td>PP</Td>
                      <Td>Passed Previously</Td>
                    </Tr>
                    <Tr>
                      <Td></Td>
                      <Td>AB</Td>
                      <Td>Absent</Td>
                    </Tr>
                    <Tr>
                      <Td></Td>
                      <Td>NA</Td>
                      <Td>Not Applicable</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </Flex>
            <Text border="2px solid black" padding="4px" m="10px 0">
              This slip should be preserved as no other certificate will be issued until the final examinations are completed and passed. Any addition by cancellation on this slip renders the stated results invalid.
            </Text>
          </Box>
          <Flex p="10px 0" align="center" flexDir="column" gap="5px">
                <Text p="0px 5%" m="0">
                  <b>CIPM HOUSE:</b> CIPM Avenue, off Obafemi Awolowo Way, Opp.
                  Lagos State Secreteriat, Alausa Ikeja Lagos.
                </Text>
                <Text p="0px 5%" m="0">
                  P.O.BOX 5312 Marina Lagos. Tel: 01 791 9501, 791 9510, 791 9482,
                  773 6134, 791 9512 
                </Text>
                <Text textAlign="center" m="0">
                  www.cipmnigeria.org
                </Text>
          </Flex>
              <Text p="5px 0" textAlign="center" bg="var(--dark-green-color)" color="var(--white-color)">Chartered Institute of Personnel Management of Nigeria - CIPM</Text>
            
        </Box>
        :<>No Statement</>}
      </Box>

    </Flex>
    
    }</>
   
  );
}

const dataSource = [
  { key: 1, range: "80-100", grade: "A", gradeName: "DISTINCTION" },
  { key: 2, range: "70-79", grade: "B", gradeName: "GOOD" },
  { key: 3, range: "60-69", grade: "C", gradeName: "CREDIT" },
  { key: 4, range: "50-59", grade: "P", gradeName: "PASS" },
  { key: 5, range: "0-49", grade: "F", gradeName: "FAIL" },
  { key: 6, range: "", grade: "PP", gradeName: "PASSED PREVIOUSLY" },
  { key: 7, range: "", grade: "AB", gradeName: "ABSENT" },
  { key: 8, range: "", grade: "NA", gradeName: "NON APPLICABLE" },
];


export default StatementResult;
